module.exports = __webpack_public_path__ + "img/information.ade58036.svg";